/* eslint-disable */
import { useEffect, useState } from "react";

export const XBOX_PLACEHOLDER_LOGO = `${process.env.PUBLIC_URL}/Xbox Logo.png`;

export const fmtShare = (v) => {
  if (v == null || !Number.isFinite(v)) return "—";
  if (v >= 10) return `${v.toFixed(1)}%`;
  if (v >= 0.1) return `${v.toFixed(2)}%`;
  return `${v.toFixed(3)}%`;
};

export const fmtInt = (v) => (Number.isFinite(Number(v)) ? Number(v).toLocaleString() : "—");

export const fmtEstimated = (v, exact = false) => {
  if (v == null || !Number.isFinite(Number(v))) return "—";
  const n = Number(v);
  if (exact || Math.abs(n) < 1000) return Math.round(n).toLocaleString();
  if (Math.abs(n) >= 1_000_000) {
    const decimals = Math.abs(n) >= 10_000_000 ? 1 : 2;
    const value = (n / 1_000_000).toFixed(decimals).replace(/0+$/, "").replace(/\.$/, "");
    return `${value}M`;
  }
  const decimals = Math.abs(n) >= 100_000 ? 0 : 1;
  return `${(n / 1000).toFixed(decimals).replace(/\.0$/, "")}K`;
};

export const ESTIMATED_PLAYERS_DISCLOSURE =
  "Modeled estimate based on mindGAME Xbox Player Share and provisional time-of-day calibration.";

export const ESTIMATED_ACTIVE_DISCLOSURE =
  "Estimated active Xbox users with foreground game or application activity. This is a modeled estimate, not a Microsoft-reported total.";

// Change is in percentage points of Player Share, not % growth.
export const fmtChange = (v) => {
  if (v == null || !Number.isFinite(v)) return "—";
  const abs = Math.abs(v);
  const s = abs >= 1 ? abs.toFixed(2) : abs.toFixed(abs >= 0.01 ? 2 : 3);
  if (Number(s) === 0) return "0.00 pts";
  return `${v > 0 ? "+" : "−"}${s} pts`;
};

export const changeTone = (v) => (v == null || Math.abs(v) < 0.005 ? "flat" : v > 0 ? "up" : "down");

export const fmtSnapshot = (t, withDate = true) => {
  const d = new Date(t);
  if (Number.isNaN(d.getTime())) return "—";
  const time = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  if (!withDate) return time;
  return `${d.toLocaleDateString([], { month: "short", day: "numeric" })} ${time}`;
};

const STORE_IMAGE_HOST = /^https:\/\/store-images\.s-microsoft\.com\//i;

// Microsoft's store image CDN resizes via ?w=; full-size art is often several MB.
export const sizedArt = (url, width) =>
  url && STORE_IMAGE_HOST.test(url) && !url.includes("?") ? `${url}?w=${width}` : url;

/** Walks an ordered list of artwork URLs, falling through on load errors. */
export function XboxArt({ candidates, width, alt = "", className, style, fallback = null, eager = false }) {
  const list = candidates || [];
  const key = list.join("|");
  const [idx, setIdx] = useState(0);
  useEffect(() => setIdx(0), [key]);

  const src = list[idx];
  if (!src) return fallback;
  return (
    <img
      src={width ? sizedArt(src, width) : src}
      alt={alt}
      className={className}
      style={style}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      draggable={false}
      onError={() => setIdx((i) => i + 1)}
    />
  );
}

export function XboxArtPlaceholder({ className = "" }) {
  return (
    <div className={`xbox-art-placeholder ${className}`}>
      <img src={XBOX_PLACEHOLDER_LOGO} alt="" draggable={false} />
    </div>
  );
}

export const typeLabel = (type) => (type === "Application" ? "App" : type === "Game" ? "Game" : "Unclassified");
